<div>
  <div class="modal-header col-12" style="justify-content: flex-end; margin-bottom: 0; border: none;">
    <img title="Close Modal" (click)="closeModal(false)" width="17" height="17" src="assets/images/cross-dark-grey.svg" style="cursor: pointer;">
  </div>
  <div class="modal-body">
    <h2 class="modal-title col-12 noTextSelect">Remove Item?</h2>
    <h3 class="deleteMsg mt-4">
      <span class="noTextSelect" style="width: 90%; float: left; margin-left: 5%;">Remove this item from this delivery for {{dateFromRemoveItem | date: 'EEE, MMMM d'}}?</span>
    </h3>
  </div>

  <div class="modal-footer removeItem col-12" (click)="closeModal(true)" style="cursor: pointer;">
    <p class="noTextSelect" style="margin: 0px;">YES CONFIRM</p>
    </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/shared/remove-cart-item/remove.component.html